import { DUPLICATE_ERROR } from '~constants'

export const validateDashboardName = (dashboards, dashboardId) => (value) => {
  const isDuplicateName = dashboards?.some(
    ({ name, id }) => id !== +dashboardId && name === value.trim()
  )
  return isDuplicateName ? DUPLICATE_ERROR : true
}
